<template>
  <div id="app" sticky-container>
    <router-view/>
  </div>
</template>

<script>
export default {
}
</script>
